import Splide from '@splidejs/splide';
import "@splidejs/splide/dist/css/splide-core.min.css";
import TomSelect from "tom-select";
import "tom-select/dist/css/tom-select.default.css";

(function() {
	const selectionCnt = document.getElementById("device-selection-cnt");

	if ( selectionCnt === null ) return;


	const removeDevice = document.getElementById("remove-device");

	const appWrapper = document.getElementById("wrapper");
	const deviceInfoWrapper = document.getElementById("device-info-wrapper");

	const deviceModal = document.getElementById("device-modal");
	const contentWrapper = deviceModal.getElementsByClassName("js-content-wrapper")[0];
	const closeModalBtns = deviceModal.getElementsByClassName("js-close");
	const selectBtns = deviceModal.getElementsByClassName("js-select");
	const spinner = deviceModal.getElementsByClassName("js-modal-spinner")[0];

	const deviceRadios = document.getElementsByClassName("js-device-radio");
	const detailsBtns = document.getElementsByClassName("js-details-btn");

	new TomSelect("#device-sort", {

		onChange: async function(value) {

			const deviceCnt = document.getElementById("devices-cnt");
			deviceCnt.innerHTML = `<svg class="mt-8 mb-12 mx-auto text-gray-400 spinner w-16 h-16" viewBox="0 0 50 50" stroke="currentColor">
				<circle class="path" stroke-linecap="round" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
			</svg>`;

			try {
				const result = await axios.post("/sort-devices", {
					sortValue: value
				});

				//! CAUSION REMOVES LISTENER!!!
				for (let i = 0; i < deviceRadios.length; i++) {
					deviceRadios[i].removeEventListener("change", deviceRadioButtonHandler);
				}
				for (let i = 0; i < detailsBtns.length; i++) {
					detailsBtns[i].removeEventListener("click", deviceDetailsBtnHandler);
				}

				deviceCnt.innerHTML = result.data;

			} catch (error) {
				console.log(error);
			}
			finally {

				for (let i = 0; i < deviceRadios.length; i++) {
					deviceRadios[i].addEventListener("change", deviceRadioButtonHandler);
				}

				for (let i = 0; i < detailsBtns.length; i++) {
					detailsBtns[i].addEventListener("click", deviceDetailsBtnHandler);
				}
			}
		}
	});

	function deviceDetailsBtnHandler() {

		const container = this.getParentByClassName("js-device-cnt");
		const name = container.getElementsByClassName("js-device-name")[0];
		const retailPrice = container.getElementsByClassName("js-device-retail")[0];
		const upfront = container.getElementsByClassName("js-device-upfront")[0];
		const installments = container.getElementsByClassName("js-device-installments")[0];
		const energyImage = container.getElementsByClassName("js-device-energy-image")[0];

		const modalSelectPill = document.getElementById("device-modal-select");
		const closeModalPill = document.getElementById("close-modal-pill");

		closeModalPill.textContent = this.dataset.btnText;

		if (this.dataset.origin == 1) {
			closeModalPill.classList.add("bg-gray-400");
			closeModalPill.classList.remove("bg-primary-500");
			modalSelectPill.classList.remove("hidden");
		}
		else {
			closeModalPill.classList.remove("bg-gray-400");
			closeModalPill.classList.add("bg-primary-500");
			modalSelectPill.classList.add("hidden");
		}

		document.getElementById("device-modal-retails-price")
			.textContent = retailPrice.textContent;

		document.getElementById("device-modal-upfront")
			.textContent = upfront.textContent;

		document.getElementById("device-modal-installments")
			.textContent = installments.textContent;

		document.getElementById("device-modal-name")
			.textContent = name.textContent;

		const energyImgElm = document.getElementById("device-modal-energy-image");

		if (energyImage == undefined) {
			energyImgElm.parentElement.classList.add("hidden");
		}
		else {
			energyImgElm.src = energyImage.src;
			energyImgElm.parentElement.classList.remove("hidden");
		}

		modalSelectPill.dataset.deviceSlug = this.dataset.deviceSlug;

		appWrapper.classList.add("overflow-y-hidden");
		deviceModal.classList.add("active");

		axios.post(`/modal-device`, {
			shortCode: this.dataset.shortCode
		})
		.then( res => {

			contentWrapper.getElementsByClassName("js-content")[0].innerHTML = res.data.content;
			contentWrapper.modalSplide = new Splide('.splide', {
				type: "slide",
				perPage: 1,
				arrows: res.data.content.includes("data-with-pagination"),
				pagination: res.data.content.includes("data-with-pagination"),
				autoplay: true,
				speed: 600
			}).mount();

			const specs = document.getElementById("device-modal-specifications");

			if (res.data.device.TechnicalCharacteristicsDocumentUrl) {
				specs.href = res.data.device.TechnicalCharacteristicsDocumentUrl;
				specs.classList.remove("hidden");
			}
			else {
				specs.src = "";
				specs.classList.add("hidden");
			}

			spinner.classList.add("hidden");
			contentWrapper.classList.remove("hidden");
		})
		.catch( err => console.log(err) )
	}

	function deviceRadioButtonHandler() {
		const container = this.getParentByClassName("js-device-cnt");
		const image = container.getElementsByClassName("js-device-img")[0];
		const name = container.getElementsByClassName("js-device-name")[0];
		const retailPrice = container.getElementsByClassName("js-device-retail")[0];
		const upfront = container.getElementsByClassName("js-device-upfront")[0];
		const installments = container.getElementsByClassName("js-device-installments")[0];

		document.getElementById("scenario-id").value = this.dataset.scenarioId;

		document.getElementById("ds-name").textContent = name.textContent;
		document.getElementById("ds-img").src = image.src;
		document.getElementById("ds-img").alt = name.textContent;
		document.getElementById("ds-price").textContent = retailPrice.textContent;
		document.getElementById("ds-upfront").textContent = upfront.textContent;
		document.getElementById("ds-installments").textContent = installments.textContent;
		document.getElementById("ds-details-btn").dataset.deviceSlug = this.dataset.deviceSlug;
		document.getElementById("ds-details-btn").dataset.shortCode = this.dataset.shortCode;

		setTimeout( function() {
			document.getElementById("scroll-point")
				.scrollIntoView({
					behavior: "smooth"
				});
		},100);

		axios.post("/search-esim-compatibility-by-shortcode", {
			shortCode: this.dataset.shortCode
		})
		.then( res => {
			 const resultCnt = document.getElementById("selected-device-compatibility");

			 resultCnt.innerHTML = res.data;
			 resultCnt.classList.remove("hidden");
		})
		.catch( err => console.log(err) );

		selectionCnt.classList.add("hidden");
		deviceInfoWrapper.classList.remove("hidden");
	}

	function closeModalHandler(event) {

		if (this == deviceModal) {
			if (event.target !== this) return;
		}

		contentWrapper.modalSplide.destroy();
		resetModal();
	}

	function resetModal() {

		deviceModal.classList.remove("active");
		appWrapper.classList.remove("overflow-y-hidden");
		spinner.classList.remove("hidden");
		contentWrapper.classList.add("hidden");
	}

	for (let i = 0; i < detailsBtns.length; i++) {
		detailsBtns[i].addEventListener("click", deviceDetailsBtnHandler);
	}

	for (let i = 0; i < closeModalBtns.length; i++) {

		closeModalBtns[i].addEventListener("click", closeModalHandler);
	}

	for (let i = 0; i < selectBtns.length; i++) {
		selectBtns[i].addEventListener("click", function() {

			const deviceRadio = document.getElementById(`${this.dataset.deviceSlug}`);

			deviceRadio.checked = true;
			deviceRadio.dispatchEvent( new Event("change") );
			resetModal();
		});
	}

	deviceModal.addEventListener("click", closeModalHandler)

	for (let i = 0; i < deviceRadios.length; i++) {
		deviceRadios[i].addEventListener("change", deviceRadioButtonHandler);
	}

	removeDevice.addEventListener("click", function() {

		selectionCnt.classList.remove("hidden");
		deviceInfoWrapper.classList.add("hidden");
		document.getElementById("selected-device-compatibility")
			.classList.add("hidden");

		for (let i = 0; i < deviceRadios.length; i++) {
			deviceRadios[i].checked = false;
		}
	})
})();
